module.exports = __webpack_public_path__ + "img/guide.77a1b2b0.svg";